import React from "react";

import { Line } from "react-chartjs-2";

import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";

import Edit from "@material-ui/icons/Edit";
import AccessTime from "@material-ui/icons/AccessTime";
import Refresh from "@material-ui/icons/Refresh";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import moment from "moment";

import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { WithApp } from "contexts/appContext";

const useStyles = makeStyles(styles);

export default WithApp(function LineChart(props) {
  const classes = useStyles();

  const dataMonth = props.monthSelected;

  const arrayDaysOfMonth = Array.from(
    Array(
      moment(
        !!dataMonth && dataMonth !== undefined ? dataMonth : moment()
      ).daysInMonth()
    ),
    (_, i) => i + 1
  );

  let dataBase = Array(arrayDaysOfMonth.length).fill(0);
  if (props.data.length > 0) {
    for (let i = 0; i < props.data.length; i++) {
      dataBase.splice(
        parseInt(props.data[i].day) - 1,
        1,
        parseFloat(props.data[i].total_amount)
      );
    }
  }

  const data = {
    labels: arrayDaysOfMonth,
    datasets: [
      {
        label: "Ventas",
        data: dataBase,
        fill: false,
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "white"
      }
    ]
  };

  const options = {
    plugins: {
      title: {
        display: true,
        text: "Periodo " + moment(props.date).format("YYYY-MM"),
        color: "white"
      },
      legend: {
        labels: {
          color: "white"
        }
      }
    },
    scales: {
      yAxes: [
        {
          title: {
            display: true,
            text: "Días"
          },
          ticks: {
            beginAtZero: true,
            color: "#FF0000"
          }
        }
      ]
    },
    responsive: true
  };

  return (
    <Card chart className={classes.cardHover}>
      <CardHeader color="info" className={classes.cardHeaderHover}>
        <Line data={data} options={options} height={100} />
      </CardHeader>
      <CardBody>
        <div className={classes.cardHoverUnder}>
          {!!props.refresh ? (
            <Tooltip
              id="tooltip-top"
              title="Refresh"
              placement="bottom"
              classes={{ tooltip: classes.tooltip }}
            >
              <Button
                simple
                color="info"
                justIcon
                onClick={() => props.refresh()}
              >
                <Refresh className={classes.underChartIcons} />
              </Button>
            </Tooltip>
          ) : undefined}
          {/* <Tooltip
            id="tooltip-top"
            title="Change Date"
            placement="bottom"
            classes={{ tooltip: classes.tooltip }}
          >
            <Button color="transparent" simple justIcon>
              <Edit className={classes.underChartIcons} />
            </Button>
          </Tooltip> */}
        </div>
        <h4 className={classes.cardTitle}>{props.title}</h4>
        {props.subTitle ? (
          <p className={classes.cardCategory}>
            {/* <span className={classes.successText}>
            <ArrowUpward className={classes.upArrowCardCategory} /> 55%
          </span> */}
            {props.subTitle}
          </p>
        ) : undefined}
      </CardBody>
      <CardFooter chart>
        {props.lastUpdate ? (
          <div className={classes.stats}>
            <AccessTime /> actualizado hace {props.lastUpdate}
          </div>
        ) : undefined}
      </CardFooter>
    </Card>
  );
});
